/* eslint-disable import/prefer-default-export */
export const ASSET_TYPES = {
  MARKUP: 'markup',
  SCRIPT: 'scripts',
  STYLE: 'styles',
}
